import React, { Component } from "react";
import { Tabs, Form, Button, message, Spin, Tooltip, Icon } from "antd";
import { connect } from "dva";
import moment from "moment";
import Container from "../../../../components/Container";
import FormCreate from "../../../../components/FormCreate/index";
import PublishModal from "../Components/PublishModal";
import WxEditor from "../../../../components/WxEditor";
import { GetQueryString } from "../../../../services/utils";
import UnSignRemind from "../Components/UnSignRemind";
import SelectFrontCover from "../Components/SelectFrontCover/index";
import ThemeModal from "../Components/ThemeModal";
import { initState } from "../models/create";
import styles from "./index.less";

const { Item } = Form;
const { TabPane } = Tabs;
const {
  FormTitle,
  DateAndTime,
  Publisher,
  FormSelect,
  FormRadioGroup,
  FormRadio,
  FormCheckboxGroup,
  MessageRemind,
  SelectUserVersion4,
  SendTime,
  RangeSelectUser
} = FormCreate;

const locationData = [
  {
    key: 0,
    label: "选填"
  },
  {
    key: 1,
    label: "必填"
  }
];

// eslint-disable-next-line camelcase
let wwei_editor = null;
let appId = GetQueryString("appId") || 40;

@Form.create()
@connect(({ createActivity, user, activityGlobal, loading }) => {
  return {
    currentUser: user.currentUser,
    ...createActivity,
    ...activityGlobal,
    pageLoading:
      loading.effects["createActivity/fetchGetTemplateDetail"] ||
      loading.effects["createActivity/fetchActivityInfo"] ||
      loading.effects["createActivity/fetchInitiatorName"] ||
      loading.effects["activityGlobal/fetchStatusList"] ||
      loading.effects["activityGlobal/fetchTypeList"] ||
      loading.effects["createActivity/fetchConfigIndexList"]
  };
})
class Create extends Component {
  constructor(props) {
    super(props);
    this.activityBizId = GetQueryString("activityBizId");
    this.activityOrgId = GetQueryString("activityOrgId");
    this.templateId = GetQueryString("templateId");
    this.typeId = GetQueryString("typeId");
    this.state = {
      scopeDeptsId: [], // 临时解决校端按规则选范围的问题
      orgRelInfoList: [],
      groupInfoList: [],
      tagInfoList: [],
      needCheckRange: false
    };
    appId = GetQueryString("appId") || 40;
  }

  componentDidMount() {
    this.fetchStatusList();
    this.fetchTypeList();
    this.fetchInitiatorName();
    wwei_editor = window.UE.getEditor("wwei_editor");
    if (this.activityBizId && this.activityOrgId) {
      this.fetchActivityInfo();
    } else if (this.templateId) {
      const { dispatch } = this.props;
      dispatch({
        type: "createActivity/fetchGetTemplateDetail",
        params: {
          templateId: this.templateId
        },
        callback: () => {
          const { formData } = this.props;
          const { content } = formData;
          wwei_editor.ready(() => {
            wwei_editor.setContent(content);
          });
        }
      });
      this.fetchConfigIndexList(this.typeId);
      return null;
    }
    return null;
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: "createActivity/reset"
    });
  }

  // 更新model数据
  handleSave = payload => {
    const { dispatch } = this.props;
    dispatch({
      type: "createActivity/save",
      payload
    });
  };

  fetchSaveValue = value => {
    const { dispatch, formData } = this.props;
    if (formData.indexList.length === 0 && value.target.value) {
      message.info("请选择打卡类型");
    }
    dispatch({
      type: "createActivity/save",
      payload: {
        formData: {
          ...formData,
          hasIndex: value.target.value,
          indexList: value ? formData.indexList : []
        }
      }
    });
  };

  fetchActivityInfo = () => {
    const { dispatch } = this.props;
    dispatch({
      type: "createActivity/fetchActivityInfo",
      params: {
        bizId: this.activityBizId,
        orgId: this.activityOrgId
      }
    }).then(res => {
      const { form } = this.props;
      const { name, scopeDeptsId } = res;
      if (!res.hasIndex) {
        this.fetchConfigIndexList(res.typeId);
      } else {
        this.changelabel(res.indexList);
      }
      wwei_editor.ready(() => {
        wwei_editor.setContent(res.content);
      });
      const { setFieldsValue } = form;
      setFieldsValue({
        name
      });
      this.setState({
        scopeDeptsId
      });
    });
  };

  fetchInitiatorName = () => {
    const { dispatch } = this.props;
    dispatch({
      type: "createActivity/fetchInitiatorName"
    });
  };

  // 获取状态列表
  fetchStatusList = () => {
    const { dispatch } = this.props;
    dispatch({
      type: "activityGlobal/fetchStatusList"
    });
  };

  // 获取活动类别列表
  fetchTypeList = () => {
    const { dispatch } = this.props;
    dispatch({
      type: "activityGlobal/fetchTypeList"
    });
  };

  // 获取指标
  fetchConfigIndexList = typeId => {
    const { dispatch } = this.props;
    if (typeId) {
      dispatch({ type: "createActivity/fetchConfigIndexList", typeId }).then(
        res => {
          this.changelabel(res);
        }
      );
    }
  };

  // 修改指标样式
  changelabel = res => {
    const { formData, dispatch } = this.props;
    const data = [];
    res.forEach(item => {
      data.push({
        ...item,
        label: `${item.name}  (单位:  ${item.unit})`,
        value: item.id
      });
    });
    dispatch({
      type: "createActivity/save",
      payload: {
        formData: {
          ...formData,
          indexList: data
        }
      }
    });
  };

  // 判断选择指标
  userCheckd = value => {
    const { formData, dispatch } = this.props;
    const { indexList } = formData;
    const data = [];
    indexList.forEach((item, index) => {
      data.push(item);
      if (value.indexOf(item.id) !== -1) {
        data[index].selected = true;
      } else {
        data[index].selected = false;
      }
    });
    dispatch({
      type: "createActivity/save",
      payload: {
        formData: {
          ...formData,
          indexList: data
        }
      }
    });
  };

  changeTab = activeKey => {
    const { dispatch } = this.props;
    dispatch({
      type: "createActivity/save",
      payload: { activeKey }
    });
  };

  /**
   * 必填项校验
   * @param fields 校验属性 数组
   * @param errMsg 校验出错提示信息
   * @param tab 出错时定位到具体tab
   */
  validateFieldsTask = (fields = [], errMsg = "", tab = "1") => {
    const { form } = this.props;
    const { validateFields } = form;
    return new Promise((resolve, reject) => {
      validateFields(fields, err => {
        if (err) {
          message.error(errMsg);
          this.changeTab(tab);
          reject(err);
        }
        return resolve();
      });
    });
  };

  handleOk = async () => {
    const { form, dispatch, formData } = this.props;
    const {
      orgRelInfoList,
      groupInfoList,
      tagInfoList,
      needCheckRange
    } = this.state;
    const { getFieldsValue } = form;
    const { selectType } = formData;
    const values = getFieldsValue();
    const { scopeSelectId } = values;

    const tab2ValidList =
      selectType === 2
        ? ["scopeSelectId", "selectRuleType"]
        : ["scopeSelectId"];

    await this.validateFieldsTask(
      ["name", "typeId", "indexList"],
      "信息填写页必填项未填写完整",
      "1"
    );
    await this.validateFieldsTask(tab2ValidList, "对象选择页未填写完整", "2");

    if (!scopeSelectId && !formData.scopeSelectId) {
      message.error("人员选择页未填写完整");
      this.changeTab("2");
      return;
    }

    if (selectType === 1 && needCheckRange) {
      const tempList = [...orgRelInfoList, ...groupInfoList];
      if (tempList.length === 0 || tagInfoList.length === 0) {
        message.error("推送范围的标签和组织均需必填");
        this.changeTab("2");
        return;
      }
    }

    await this.validateFieldsTask(
      [
        "publisher",
        "startDate",
        "cycleRemindType",
        "remindTitle",
        "cycleRemindTaskId",
        "endDate"
      ],
      "发送属性页未填写完整",
      "3"
    );
    dispatch({
      type: "createActivity/save",
      payload: { publishModalVisible: true }
    });
  };

  changeLabelType = e => {
    const { dispatch, formData, form } = this.props;
    form.setFieldsValue({
      scopeSelectId: "",
      selectRuleType: [1]
    });
    this.setState({
      scopeDeptsId: [],
      groupInfoList: [],
      orgRelInfoList: [],
      tagInfoList: []
    });
    dispatch({
      type: "createActivity/save",
      payload: {
        formData: {
          ...formData,
          selectType: e.target.value,
          scopeSelectId: ""
        }
      }
    });
  };

  // 规则范围的回调,临时解决校端规则范围传递deptId
  handleRuleSelectCallback = data => {
    const {
      deptInfoList = [],
      groupInfoList = [],
      orgInfoList = [],
      orgRelInfoList = [],
      tagInfoList = []
    } = data;
    const tempInfoList = [
      ...deptInfoList,
      ...groupInfoList,
      ...orgInfoList,
      ...orgRelInfoList,
      ...tagInfoList
    ];
    const tempDeptList = [];
    tempInfoList.forEach(item => {
      tempDeptList.push(item.id);
    });
    this.setState({
      scopeDeptsId: tempDeptList
    });
  };

  // rangeSelectUsr的回调，处理选择结果list，用来判断两个都要填
  handleSetRangeList = data => {
    const { groupInfoList, orgRelInfoList, tagInfoList } = data;
    this.setState({
      groupInfoList,
      orgRelInfoList,
      tagInfoList,
      needCheckRange: true
    });
  };

  // 更改图片后的回调
  handleChangeActivityCover = coverUrl => {
    const { form } = this.props;
    const { setFieldsValue } = form;
    setFieldsValue({ activityCover: coverUrl });
  };

  // 切换未提醒radio时，要把未提醒设置的内容清空
  handleUnAttendRemindChange = e => {
    const { formData } = initState || {};
    const {
      cycleRemindTaskId,
      cycleRemindType,
      remindTitleType,
      remindCover,
      remindTitle
    } = formData || {};
    if (!e.target.value) {
      this.handleFormDataChange({
        cycleRemindTaskId,
        cycleRemindType,
        remindTitleType,
        remindCover,
        remindTitle
      });
    }
  };

  // 更新表单数据
  handleFormDataChange = payload => {
    const { form, formData, dispatch } = this.props;
    const { setFieldsValue, getFieldsValue } = form;
    const values = getFieldsValue();
    setFieldsValue({ ...payload });
    const { indexList } = formData || {};
    dispatch({
      type: "createActivity/save",
      payload: {
        formData: {
          ...formData,
          ...values,
          ...payload,
          indexList
        }
      }
    });
  };

  saveActivity = () => {
    const { form, formData } = this.props;
    const { getFieldsValue } = form;
    const values = getFieldsValue();
    values.indexList = formData.indexList;
    wwei_editor = window.UE.getEditor("wwei_editor");
    const content = wwei_editor.getContent();
    if (this.activityBizId && this.activityOrgId) {
      const params = {
        ...formData,
        ...values,
        endDate: moment(values.endDate).format("YYYY-MM-DD HH:mm"),
        content,
        startDate:
          values.isTiming === 0
            ? ""
            : moment(values.startDate).format("YYYY-MM-DD HH:mm"),
        bizId: this.activityBizId,
        orgId: this.activityOrgId,
        cycleRemindType:
          values.cycleRemindType?.length === 2
            ? 0
            : (values.cycleRemindType && values.cycleRemindType[0]) || 1,
        selectRuleType:
          // eslint-disable-next-line
          values.selectRuleType?.length === 2
            ? 0
            : values.selectRuleType
            ? values.selectRuleType[0]
            : 1
      };
      this.fetchCreateActivity(params);
    } else {
      const params = {
        ...formData,
        ...values,
        endDate: moment(values.endDate).format("YYYY-MM-DD HH:mm"),
        content,
        cycleRemindType:
          values.cycleRemindType?.length === 2
            ? 0
            : (values.cycleRemindType && values.cycleRemindType[0]) || 1,
        selectRuleType:
          // eslint-disable-next-line
          values.selectRuleType?.length === 2
            ? 0
            : values.selectRuleType
            ? values.selectRuleType[0]
            : 1,
        startDate:
          values.isTiming === 0
            ? ""
            : moment(values.startDate).format("YYYY-MM-DD HH:mm")
      };
      this.fetchCreateActivity(params);
    }
  };

  fetchCreateActivity = params => {
    const { dispatch } = this.props;
    const { scopeDeptsId } = this.state;
    dispatch({
      type: "createActivity/fetchCreateActivity",
      params: {
        ...params,
        scopeDeptsId
      }
    });
  };

  nextStep = () => {
    const { activeKey } = this.props;
    this.changeTab(`${Number(activeKey) + 1}`);
  };

  preStep = () => {
    const { activeKey, dispatch } = this.props;
    dispatch({
      type: "createActivity/save",
      payload: { activeKey: `${Number(activeKey) - 1}` }
    });
  };

  // rangeSelectUser的label
  renderRangeSelectUserLabel = () => {
    return (
      <Tooltip
        placement="top"
        title="从已有系统标签规则选择组织精准推送"
        autoAdjustOverflow
      >
        系统标签内组织精准推送
        <Icon type="question-circle" style={{ marginLeft: 4 }} />
      </Tooltip>
    );
  };

  resetInitiatorName = value => {
    const { initiatorNameData, form } = this.props;
    const { userName, deptName } = initiatorNameData;
    const { setFieldsValue } = form;
    setFieldsValue({ publisher: value === 1 ? userName : deptName });
  };

  renderTabTitle = (activeKey, title, index) => {
    return (
      <span>
        <i
          className={
            activeKey === index
              ? "common-icon-style active-style"
              : "common-icon-style icon-style"
          }
        >
          {index}
        </i>
        {title}
      </span>
    );
  };

  renderFooter = () => {
    const { activeKey, form } = this.props;
    const { getFieldsValue } = form;
    let footerParams = {};
    const { isTiming } = getFieldsValue();

    if (activeKey === "1" || activeKey === "2") {
      footerParams = {
        states: !0,
        demFooter: (
          <>
            {activeKey === "2" && (
              <Button type="default" onClick={this.preStep}>
                上一步
              </Button>
            )}
            <Button type="primary" onClick={this.nextStep}>
              下一步
            </Button>
          </>
        )
      };
    } else {
      footerParams = {
        states: !0,
        demFooter: (
          <>
            <Button type="default" onClick={this.preStep}>
              上一步
            </Button>
            <Button type="primary" onClick={() => this.handleOk()}>
              {isTiming ? "保存" : "发布"}
            </Button>
          </>
        )
      };
    }
    return footerParams;
  };

  render() {
    const {
      form,
      activeKey,
      formData,
      currentUser,
      spinProps,
      typeList,
      status,
      pageLoading,
      initiatorNameData
    } = this.props;
    const { getFieldsValue, getFieldDecorator } = form;
    const { spinning, tip } = spinProps;
    const { deptName } = initiatorNameData;
    const {
      name = "",
      scopeSelectId = "",
      endDate = null,
      content = "",
      authoritySelectId = "",
      publishType = 0,
      typeId = "",
      hasIndex = 0,
      saveIndexList,
      selectType,
      messageRemindFlag = 1,
      visibleRange = 0,
      isTiming = 0,
      startDate = moment().add(2, "hours"),
      cycleRemindTaskId,
      cycleRemindType,
      selectRuleType,
      activityCover,
      remindCover,
      remindTitle,
      locationFlag,
      maskId,
      unAttendRemind,
      remindTitleType,
      publisher
    } = formData;
    const { orgType } = currentUser || {};
    const titleProps = {
      form,
      value: name,
      label: "活动标题",
      keyName: "name",
      maxLength: 100,
      disabled: !!this.activityBizId,
      suffix: `${(getFieldsValue().name && getFieldsValue().name.length) ||
        0}/100`
    };

    const labelTypeProps = {
      form,
      value: selectType,
      label: "选择方式",
      keyName: "selectType",
      isRequired: true,
      itemFormProps: {
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 18
        },
        style: { marginBottom: 6 }
      },
      RadioGroupData:
        orgType !== "school"
          ? [
              {
                label: "按规则选范围",
                value: 2,
                questionTips:
                  "按规则选范围，活动创建后，新加入通讯录的用户符合以下设置条件且在活动进行期间，均可参与本次活动。"
              },
              { label: "本组织及直属学校", value: 0 },
              {
                label: "直属、非直属学校",
                value: 1,
                questionTips:
                  "按直属、非直属选择范围，仅展示系统标签，请在通讯录-系统标签中确定选择的标签下有用户。选择后活动范围以本次选择为主，活动创建后新加入标签中的人员无法参与活动，需更新活动对象才可生效。"
              }
            ]
          : [
              {
                label: "按规则选范围",
                value: 2,
                questionTips:
                  "按规则选范围，活动创建后，新加入通讯录的用户符合以下设置条件且在活动进行期间，均可参与本次活动。"
              },
              {
                label: "指定活动范围",
                value: 0,
                questionTips:
                  "指定活动范围，选择后活动范围以本次选择为主，活动创建后新加入标签中的人员无法参与活动，需更新活动对象才可生效。"
              }
            ],
      radioStyle: {
        display: "inline"
      },
      spanNum: orgType !== "school" ? 8 : 12,
      onChange: this.changeLabelType
    };

    const rulesSelectProps = {
      form,
      value: scopeSelectId,
      appName: "活动打卡",
      appId: 40,
      orgType,
      label: "选择需要发送的组织",
      message: "请选择需要发送的组织",
      keyName: "scopeSelectId",
      isRequired: true,
      callback: data => this.handleRuleSelectCallback(data),
      selectProps: {
        multiple: true,
        selectType: "dept",
        strictOrgRel: false,
        showTabList:
          orgType !== "school"
            ? ["orgRel"]
            : ["dept", "innerContacts", "schoolContacts"],
        dialogProps: {
          title: "选择对象"
        },
        searchPlaceholder: "搜索名称",
        selectSignature: scopeSelectId,
        isSaveSelectSignature: true,
        requestParams: {
          strictUser: true,
          selectTypeList:
            orgType !== "school"
              ? ["org_rel"]
              : ["dept", "innerContacts", "schoolContacts"]
        }
      },
      itemFormProps: {
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 18
        }
      }
    };

    const selectOrgProps = {
      form,
      value: scopeSelectId,
      appName: "活动打卡",
      appId: 40,
      orgType,
      label: "对象选择",
      message: "请选择需要发送的对象",
      keyName: "scopeSelectId",
      isRequired: true,
      selectProps: {
        multiple: true,
        selectType: "user",
        strictOrgRel: false,
        showTabList:
          orgType !== "school"
            ? ["dept", "innerContacts", "group", "tags"]
            : ["dept", "innerContacts", "schoolContacts", "tags"],
        dialogProps: {
          title: "选择对象"
        },
        searchPlaceholder: "搜索名称",
        selectSignature: scopeSelectId,
        isSaveSelectSignature: true,
        requestParams: {
          selectTypeList: ["user"]
        }
      },
      itemFormProps: {
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 18
        }
      }
    };

    const rangeSelectUserProps = {
      form,
      value: scopeSelectId,
      appName: "活动打卡",
      appId: 40,
      orgType,
      label: this.renderRangeSelectUserLabel(),
      message: "请选择打卡范围",
      keyName: "scopeSelectId",
      isRequired: true,
      funCallbackSignature: data => this.handleSetRangeList(data),
      tagProps: {
        subtitle: "已选对象",
        btnText: "选择",
        btnDetele: true
      },
      orgRelProps: {
        subtitle: "已选对象",
        btnText: "选择",
        btnDetele: true,
        showTabList: ["orgRel"]
      },
      itemFormProps: {
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 18
        }
      }
    };

    const sendTargetProps = {
      value: selectRuleType,
      keyName: "selectRuleType",
      label: "选择需要发送的对象",
      checkboxGroupOptions: [
        {
          value: 1,
          label: "学生"
        },
        {
          value: 2,
          label: "教职工"
        }
      ],
      spanNum: 3,
      isRequired: true,
      form,
      message: "请选择发送对象",
      itemFormProps: {
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 18
        }
      }
    };

    const samePowerProps = {
      ...selectOrgProps,
      selectProps: {
        ...selectOrgProps.selectProps,
        showTabList: ["dept", "innerContacts"],
        selectSignature: authoritySelectId
      },
      value: authoritySelectId,
      label: "相同权限人",
      message: "请选择相同权限人",
      keyName: "authoritySelectId",
      isRequired: false,
      tips: "说明: 选择的人员与创建人拥有相同权限",
      itemFormProps: {}
    };

    const formSelectProps = {
      form,
      label: "打卡分类",
      value: typeId,
      keyName: "typeId",
      message: "请选择打卡分类",
      selfValue: "typeId",
      selfLabel: "typeName",
      optionData: typeList,
      isRequired: true,
      onChange: value => {
        this.fetchConfigIndexList(value);
      }
    };

    const visibleRangeProps = {
      form,
      label: "动态可见范围",
      value: visibleRange,
      keyName: "visibleRange",
      isRequired: true,
      RadioGroupData: [
        {
          label: "全区可见",
          value: 1,
          questionTips:
            "当前活动所有发布的动态内容对全区成员可见，在全区动态处展示"
        },
        {
          label: "打卡范围及所在部门成员/岗位成员可见",
          value: 0,
          questionTips:
            "局校活动时，局端可查看到所有下属学校的动态，校端仅可查看本校动态"
        }
      ],
      tips:
        "说明: 已设置的范围，仅可查看活动的动态内容。活动的参与范围以打卡范围的设置为准。"
    };

    const checkButton = {
      form,
      value: hasIndex,
      label: "打卡明细",
      keyName: "hasIndex",
      isRequired: false,
      RadioGroupOptions: [
        { label: "是", value: 1 },
        { label: "否", value: 0 }
      ],
      onChange: value => this.fetchSaveValue(value)
    };

    const CheckBoxs = {
      form,
      value: saveIndexList,
      keyName: "indexList",
      label: "统计指标",
      isRequired: true,
      message: "请选择指标项",
      checkboxGroupOptions: formData.indexList,
      spanNum: 24,
      onChange: value => this.userCheckd(value)
    };

    const endTimeProps = {
      form,
      value: endDate,
      label: "截止时间",
      keyName: "endDate",
      datePickerFormat: "YYYY-MM-DD HH:mm",
      message: "请选择截止时间",
      showTime: { defaultValue: moment("00:00", "HH:mm") },
      myRules: [{ required: true, message: "请设置截止时间" }]
      // onOk: this.handleEndTime
    };

    // 未参与提醒
    const unAttendRemindProps = {
      form,
      label: "未参与提醒",
      value: unAttendRemind,
      keyName: "unAttendRemind",
      isRequired: false,
      spanNum: 12,
      onChange: this.handleUnAttendRemindChange,
      radioStyle: {
        display: "inline"
      },
      RadioGroupData: [
        {
          label: "提醒",
          value: 1
        },
        {
          label: "不提醒",
          value: 0
        }
      ]
    };

    const publisherProps = {
      form,
      nameKeyName: "publisher",
      typeKeyName: "publishType",
      initiatorNameType: publishType,
      initiatorName: this.activityBizId ? publisher : deptName,
      resetInitiatorName: this.resetInitiatorName,
      typeGroupOptions: [
        { label: "部门", value: 0 },
        { label: "个人", value: 1 }
      ]
    };

    const messageRemindProps = {
      options: [
        {
          value: 1,
          label: "全部人员"
        },
        {
          value: 2,
          label: "新增人员"
        },
        {
          value: 0,
          label: "不提醒"
        }
      ],
      form,
      keyName: "messageRemindFlag",
      value: messageRemindFlag,
      label: "活动创建提醒",
      isRequired: true
    };

    // 活动封面
    const activityCoverProps = {
      tips: "说明：建议尺寸900*383，最大不超过5M，点击图片修改"
    };

    // 打卡定位
    const signLocationProps = {
      form,
      label: "打卡定位",
      value: locationFlag,
      keyName: "locationFlag",
      message: "请选择打卡定位",
      selfKey: "key",
      selfValue: "key",
      optionData: locationData
    };

    const sendTimeProps = {
      form,
      isTiming,
      value: moment(startDate, "YYYY.MM.DD HH:mm"),
      formatDate: "YYYY-MM-DD HH:mm",
      keyName: "startDate"
    };

    const unSignRemindProps = {
      form,
      cycleRemindTaskId,
      cycleRemindType,
      remindCover,
      remindTitle,
      remindTitleType,
      appId
    };

    return (
      <Container
        breStates={!0}
        version={2}
        defaultPadding
        isPathParams
        footerParams={this.renderFooter()}
      >
        <div className={styles["activity-create-spin"]}>
          <Spin spinning={spinning || pageLoading || false} tip={tip}>
            <div className={styles.root}>
              <FormCreate>
                <Tabs
                  defaultActiveKey="1"
                  activeKey={activeKey}
                  onChange={this.changeTab}
                >
                  <TabPane
                    tab={this.renderTabTitle(activeKey, "信息填写", "1")}
                    key="1"
                  >
                    <FormTitle {...titleProps} />
                    <Item label="活动内容" className="meeting-content">
                      {getFieldDecorator("content", {
                        initialValue: content,
                        rules: [{ required: false, message: "请输入活动内容" }]
                      })(<WxEditor showTemplate={false} />)}
                    </Item>
                    <FormSelect {...formSelectProps} />
                    {orgType !== "school" && (
                      <FormRadio {...visibleRangeProps} />
                    )}
                    <FormRadioGroup {...checkButton} />
                    {hasIndex ? <FormCheckboxGroup {...CheckBoxs} /> : null}
                  </TabPane>
                  <TabPane
                    tab={this.renderTabTitle(activeKey, "对象选择", "2")}
                    key="2"
                    forceRender
                  >
                    <div style={{ marginBottom: 32 }}>
                      <FormRadio {...labelTypeProps} />
                      {selectType === 2 && (
                        <SelectUserVersion4 {...rulesSelectProps} />
                      )}
                      {selectType === 0 && (
                        <SelectUserVersion4 {...selectOrgProps} />
                      )}
                      {selectType === 1 && (
                        <RangeSelectUser {...rangeSelectUserProps} />
                      )}
                    </div>
                    {selectType === 2 && orgType !== "school" && (
                      <FormCheckboxGroup {...sendTargetProps} />
                    )}
                  </TabPane>
                  <TabPane
                    tab={this.renderTabTitle(activeKey, "发送属性", "3")}
                    key="3"
                    forceRender
                  >
                    <Publisher {...publisherProps} />
                    <SelectUserVersion4 {...samePowerProps} />
                    <DateAndTime {...endTimeProps} />
                    <MessageRemind {...messageRemindProps} />
                    {getFieldsValue().messageRemindFlag !== 0 && (
                      <Item label="推送封面" style={{ marginBottom: 15 }}>
                        {getFieldDecorator("activityCover", {
                          initialValue: activityCover,
                          valuePropName: "coverUrl"
                        })(<SelectFrontCover {...activityCoverProps} />)}
                      </Item>
                    )}
                    <FormRadio {...unAttendRemindProps} />
                    {!!getFieldsValue().unAttendRemind && (
                      <UnSignRemind {...unSignRemindProps} />
                    )}
                    <FormSelect {...signLocationProps} />
                    <Item label="活动主题蒙层" style={{ marginBottom: 15 }}>
                      {getFieldDecorator("maskId", {
                        initialValue: maskId,
                        valuePropName: "maskId"
                      })(<ThemeModal maskId={maskId} />)}
                    </Item>
                    {(this.activityBizId && status === 0 && isTiming === 0) ||
                    (this.activityBizId && status !== 0) ? null : (
                      <SendTime {...sendTimeProps} />
                    )}
                  </TabPane>
                </Tabs>
              </FormCreate>
              <PublishModal
                scopeSelectId={getFieldsValue().scopeSelectId || scopeSelectId}
                values={getFieldsValue()}
                handleOk={this.saveActivity}
                orgType={orgType}
                handleCancel={() => {
                  this.handleSave({ publishModalVisible: false });
                }}
              />
            </div>
          </Spin>
        </div>
      </Container>
    );
  }
}

export default Create;
